import { call } from 'redux-saga/effects'
// @ts-expect-error
import { GET_POLICY_ENDPOINT } from 'app/constants/api'
// @ts-expect-error
import * as REQUESTS from 'app/constants/requests'
// @ts-expect-error
import makeAPIRequest from 'store/entities/api/sagas/index'
import { IUploadFileToS3, IFetchPolicy } from 'store/entities/api/sagas/interfaces'


export function* uploadFileToS3({ file, ext, entity, params}: IUploadFileToS3)  {
  const response = yield call(fetchPolicy, { entity, ext, params })
  const body = response.data
  // eslint-disable-next-line no-prototype-builtins
  if (body.hasOwnProperty('data')) {
    // eslint-disable-line no-prototype-builtins
    const { fields, url, cdn } = body.data
    const formData = new FormData()
    formData.append('acl', 'public-read')
    formData.append('key', fields['key'])
    formData.append('bucket', fields['bucket'])
    formData.append('X-Amz-Algorithm', fields['X-Amz-Algorithm'])
    formData.append('X-Amz-Credential', fields['X-Amz-Credential'])
    formData.append('X-Amz-Date', fields['X-Amz-Date'])
    formData.append('Policy', fields['Policy'])
    formData.append('X-Amz-Signature', fields['X-Amz-Signature'])
    formData.append('file', file)

    yield call(
      makeAPIRequest,
      url,
      {
        method: 'post',
        data: formData,
        withCredentials: false,
        crossDomain: true,
      },
      true
    )
    if (params && params.hash !== undefined) {
      return `${cdn}/${fields['key']}?${params.hash}`
    }
    return `${cdn}/${fields['key']}`
  } else {
    throw new Error("File hasn't been saved")
  }
}

export function* fetchPolicy({ entity, ext, params }: IFetchPolicy) {
  return yield call(makeAPIRequest, GET_POLICY_ENDPOINT(entity, ext), {
    method: REQUESTS.GET,
    params,
  })
}
